import { useSelector } from 'react-redux';

import type { Session, UserPermission } from '@cobliteam/common-types';

import { type WebData, isWebDataSuccess } from '@cobliteam/api-lib';

import type { AppState } from '@cobliteam/store';

const checkAccessAllowed = (loginWebData: WebData<Session>, requiredPermission: UserPermission) => {
  if (isWebDataSuccess(loginWebData)) {
    const userPermissions = loginWebData.data.user.grantedPermissions;
    return userPermissions.includes(requiredPermission);
  }

  return false;
};

const usePermissions = () => {
  const loginWebData = useSelector((state: AppState) => state.login.loginWebData);

  const isAccessAllowed = (requiredPermission: UserPermission) => checkAccessAllowed(loginWebData, requiredPermission);

  return { isAccessAllowed };
};

export { checkAccessAllowed };
export default usePermissions;
